import axios from 'axios';
import { showLoading, hideLoading} from 'react-redux-loading-bar'

import store from '../store'
const http = axios.create();
http.interceptors.request.use(config => {
    store.dispatch(showLoading())
    return config;

}, error => {
    store.dispatch(hideLoading())
    return Promise.reject(error);
});

http.interceptors.response.use(response => {
    store.dispatch(hideLoading())
    return response;
}, error => {
    store.dispatch(hideLoading())
    return Promise.reject(error);
});

export default http;